import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  Input,
  InputNumber,
  Select,
  Checkbox,
  Form,
  Typography
} from 'antd'

const { Text } = Typography

export const VoidTransactionModal = ({
  visible,
  transaction,
  onOk,
  onCancel,
  loading
}) => {
  const [reason, setReason] = useState('')
  useEffect(() => {
    if (visible) setReason('')
  }, [visible])
  return (
    <Modal
      title="Аннулировать транзакцию"
      visible={visible}
      onOk={() => onOk(reason)}
      onCancel={onCancel}
      okText="Аннулировать"
      okButtonProps={{ danger: true, loading }}
      cancelText="Отмена"
    >
      <Text>
        Транзакция {transaction?.vendorTransactionId || transaction?.id} будет
        помечена как аннулированная и исключена из статистики. Запись не
        удаляется.
      </Text>
      <Input.TextArea
        style={{ marginTop: 12 }}
        rows={3}
        placeholder="Причина аннулирования"
        value={reason}
        onChange={e => setReason(e.target.value)}
      />
    </Modal>
  )
}

export const LinkTransactionModal = ({
  visible,
  transaction,
  onOk,
  onCancel,
  loading
}) => {
  const [userId, setUserId] = useState('')
  useEffect(() => {
    if (visible) setUserId('')
  }, [visible])
  return (
    <Modal
      title="Привязать транзакции к пользователю"
      visible={visible}
      onOk={() => onOk(userId.trim())}
      onCancel={onCancel}
      okText="Привязать"
      okButtonProps={{ loading, disabled: !userId.trim() }}
      cancelText="Отмена"
    >
      <Text>
        Все транзакции с Original ID{' '}
        <Text code>{transaction?.originalTransactionId || '—'}</Text> будут
        привязаны к указанному пользователю, подписка пересчитается.
      </Text>
      <Input
        style={{ marginTop: 12 }}
        placeholder="ID пользователя (ObjectId)"
        value={userId}
        onChange={e => setUserId(e.target.value)}
      />
    </Modal>
  )
}

export const ManualTransactionModal = ({ visible, onOk, onCancel, loading }) => {
  const [form] = Form.useForm()
  useEffect(() => {
    if (visible) form.resetFields()
  }, [visible, form])
  return (
    <Modal
      title="Создать чек вручную"
      visible={visible}
      onOk={() => form.submit()}
      onCancel={onCancel}
      okText="Создать"
      okButtonProps={{ loading }}
      cancelText="Отмена"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ plan: 'premium', months: 1, applyToSubscription: true }}
        onFinish={values => onOk(values)}
      >
        <Form.Item
          name="userId"
          label="ID пользователя"
          rules={[{ required: true, message: 'Укажите ID пользователя' }]}
        >
          <Input placeholder="ObjectId пользователя" />
        </Form.Item>
        <Form.Item name="plan" label="План" rules={[{ required: true }]}>
          <Select
            options={[
              { value: 'basic', label: 'basic' },
              { value: 'premium', label: 'premium' },
              { value: 'exclusive', label: 'exclusive' }
            ]}
          />
        </Form.Item>
        <Form.Item name="months" label="Месяцы" rules={[{ required: true }]}>
          <InputNumber min={1} max={36} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item name="comment" label="Комментарий">
          <Input.TextArea rows={2} placeholder="Например: оплата переводом" />
        </Form.Item>
        <Form.Item name="applyToSubscription" valuePropName="checked">
          <Checkbox>Применить к подписке (продлить срок)</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  )
}

const modalProps = {
  visible: PropTypes.bool.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool
}
VoidTransactionModal.propTypes = { ...modalProps, transaction: PropTypes.object }
LinkTransactionModal.propTypes = { ...modalProps, transaction: PropTypes.object }
ManualTransactionModal.propTypes = modalProps
